// extracted by css-extract-rspack-plugin
export default {"assigneeItem":"Assignees-module__assigneeItem___7NBI","assigneeName":"Assignees-module__assigneeName__vcDvE"};